import { Outlet } from '@tanstack/react-router'

export const Route = createFileRoute({
  component: PublicLayout,
})

function PublicLayout() {
  // Public routes have no auth wrapper - just render the content
  return <Outlet />
}
